import Button from '@/features/shared/Button';
import ContentContainer from '@/features/shared/ContentContainer';
import FourFiveColumnContent from '@/features/shared/FourFiveColumnContent';
import { MuiContainer, MuiTypography } from '@/features/shared/material-ui';
import { CardResult } from '@/features/SolutionMarketplace/Card';
import { Theme } from '@/utils/constants';
import { getTagLabel } from '@/utils/helpers';
import clsx from 'clsx';
import React from 'react';
import useStyles from './RelatedSolution.styles';

const MAX_LENGTH_DESCRIPTION = 300;
const MAX_LENGTH_TAGS = 2;

const getCardProps = (card: any) => {
  const {
    cardImage,
    cardDescription,
    cardHeading,
    buttonLink,
    keys,
    isGenetecCertified: certified,
  } = card || {};

  const description =
    cardDescription.length > MAX_LENGTH_DESCRIPTION
      ? `${cardDescription.substring(0, MAX_LENGTH_DESCRIPTION)}...`
      : cardDescription;

  const tagList = keys.length > MAX_LENGTH_TAGS ? keys.slice(0, MAX_LENGTH_TAGS) : keys;

  const tags = tagList.map((tag: string) => getTagLabel(tag));

  return {
    tags,
    cardImage,
    cardHeading,
    cardDescription: description,
    url: buttonLink.href || '#',
    certified,
  };
};

const RelatedSolution = ({
  curatedList,
  contentButtons,
  cardTheme = Theme.light,
  cardColor,
  presentation,
  labels,
  config,
}: any) => {
  const classes = useStyles({});
  const { contentList = [], listSuperheading, listTitle, cta } = curatedList || {};
  const filterContentList = contentList;
  const { topSpacing, bottomSpacing, topBackgroundColor, bottomBackgroundColor } =
    presentation || {};
  const rootClasses = clsx(classes.root, 'gtm-headline-container', `${cardTheme}-theme`);

  return (
    <ContentContainer
      topSpacing={topSpacing}
      bottomSpacing={bottomSpacing}
      topBackgroundColor={topBackgroundColor}
      bottomBackgroundColor={bottomBackgroundColor}
    >
      <MuiContainer>
        {contentButtons?.curatedList}
        <div className={rootClasses}>
          {(listSuperheading || listTitle) && (
            <div className={classes.headerCard}>
              {listSuperheading && (
                <MuiTypography variant="overline" component="div" className={classes.superHeading}>
                  {listSuperheading}
                </MuiTypography>
              )}
              {listTitle && (
                <MuiTypography
                  variant="h4"
                  component="h3"
                  className={clsx(classes.title, 'gtm-headline')}
                >
                  {listTitle}
                </MuiTypography>
              )}
            </div>
          )}
          {filterContentList.length > 0 && (
            <FourFiveColumnContent
              className={classes.contentCards}
              columnCount={3}
              columns={filterContentList.map((card: any, idx: number) => {
                return (
                  <CardResult
                    {...getCardProps(card)}
                    labels={labels}
                    config={config}
                    theme={cardTheme}
                    cardColor={cardColor}
                  />
                );
              })}
            />
          )}
          {cta?.displayText && (
            <div className={classes.ctaWrapper}>
              <Button link={cta} theme={cardTheme} className="gtm-see-all" />{' '}
            </div>
          )}
        </div>
      </MuiContainer>
    </ContentContainer>
  );
};

export default RelatedSolution;
